import { getElevation } from '@m1/geo-utils';
import OlMap from '@m1/ol-map';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { toLonLat } from 'ol/proj';
import React, { useMemo } from 'react';
import { RiCrosshair2Line } from 'react-icons/ri';
import { useStore, useDispatch, useSelector } from 'react-redux';

import actions from '@/actions';
import { CommandButton } from '@/components/ui/kit/Button';
import useHandlerWithMoveCheck from '@/hooks/useHandlerWithMoveCheck';

const ClickPoint = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.editor.mode);
  const map = OlMap.getMap();
  const { handleWithMoveCheck } = useHandlerWithMoveCheck();

  const pressed = useMemo(() => {
    return mode === 'path/point';
  }, [mode]);

  useUpdateEffect(() => {
    if (!pressed) return;

    map.on('click', handleClick);

    return () => {
      map.un('click', handleClick);
    };
  }, [pressed]);

  const handleClick = (e) => {
    const features = map.getFeaturesAtPixel(e.pixel);

    // 클릭 지점에 Feature 존재 시
    if (features.length > 0) return;

    const [lng, lat] = toLonLat(e.coordinate);
    addWaypoint({ lat, lng });
  };

  // 경로점 추가
  const addWaypoint = async (position) => {
    const elevation = await getElevation(position);
    const { altitude } = store.getState().editor.config;
    const waypoint = { position, elevation, altitude };

    dispatch(actions.mission.appendWaypoint(waypoint));
  };

  const toggle = () => {
    if (pressed) {
      dispatch(actions.editor.changeMode(null));
    } else {
      dispatch(actions.editor.changeMode('path/point'));
    }
  };

  return <CommandButton Icon={RiCrosshair2Line} text="Point" pressed={pressed} onClick={handleWithMoveCheck(toggle)} />;
};

export default ClickPoint;
